import "./form-util-service.scss";

import { UtilServiceFormSchema } from "@factory/form/form.rule";
import { useQyGetUtilCategory } from "@factory/query/util-category.query";
import { LabelValue } from "@shared/models/label-value.interface";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputTextareaControl from "@shared/ui/hook-form/input-textarea-control/input-textarea-control";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import { useFilterUtilServiceContext } from "../filter-util-service/filter-util-service.context";

type InputFormSchema = UtilServiceFormSchema;
export function FormUtilService() {
  const { control, setValue } = useFormContext<UtilServiceFormSchema>();
  const { getFilterEntityValues } = useFilterUtilServiceContext();
  const { category } = getFilterEntityValues();

  const { data: category_ } = useQyGetUtilCategory("", 99999);
  const categoryData = category_?.data || [];
  const options = LabelValue.MapArray(
    categoryData,
    (label) => label.name || "-",
    (value) => value.code
  );

  const categoryDropdownElement = useCallback(() => {
    if (category) {
      setValue("category", category);
      return null;
    }

    return (
      <DropdownControl<InputFormSchema>
        control={control}
        name="category"
        label="Category Name"
        className="w-full md:w-3/4"
        options={options}
      />
    );
  }, [category, options]);

  return (
    <div id="FormUtilService" className="util-service">
      {categoryDropdownElement()}
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amount"
        label="Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter amount"
      />
    </div>
  );
}

export default FormUtilService;
